(function () {
  'use strict';

  var MAIN_NOTICE_KEY = 'Aviso de personalización';
  var EXTRA_NOTICE_KEY = 'Aviso de personalización extra';
  var mapNode = document.querySelector('[data-cdf-patch-message-map]');

  if (!mapNode) return;

  var rawMap = { main: {}, extra: {} };

  try {
    rawMap = JSON.parse(mapNode.textContent || '{}');
  } catch (error) {
    console.warn('CDF patch messages: no se pudo leer el mapa de avisos.', error);
    return;
  }

  function normalizeKey(value) {
    return String(value || '').trim().toLocaleLowerCase();
  }

  function buildNormalizedMap(source) {
    var result = {};
    Object.keys(source || {}).forEach(function (key) {
      var message = String(source[key] || '').trim();
      if (!message) return;
      result[normalizeKey(key)] = message;
    });
    return result;
  }

  var messages = {
    main: buildNormalizedMap(rawMap.main),
    extra: buildNormalizedMap(rawMap.extra)
  };

  function getMessage(kind, value) {
    return messages[kind] && messages[kind][normalizeKey(value)]
      ? messages[kind][normalizeKey(value)]
      : '';
  }

  function getNoticeKey(kind) {
    return kind === 'extra' ? EXTRA_NOTICE_KEY : MAIN_NOTICE_KEY;
  }

  function syncProperties(properties) {
    if (!properties || typeof properties !== 'object' || Array.isArray(properties)) {
      return properties;
    }

    delete properties[MAIN_NOTICE_KEY];
    delete properties[EXTRA_NOTICE_KEY];

    var mainMessage = getMessage('main', properties.Parche || '');
    var extraMessage = getMessage('extra', properties['Parche extra'] || '');

    if (mainMessage) properties[MAIN_NOTICE_KEY] = mainMessage;
    if (extraMessage) properties[EXTRA_NOTICE_KEY] = extraMessage;

    return properties;
  }

  function syncPayload(payload) {
    if (!payload || typeof payload !== 'object') return payload;

    if (Array.isArray(payload.items)) {
      payload.items.forEach(function (item) {
        if (item && item.properties) syncProperties(item.properties);
      });
    }

    if (payload.properties) syncProperties(payload.properties);

    return payload;
  }

  function isCartPropertyEndpoint(input) {
    var rawUrl = typeof input === 'string' ? input : input && input.url ? input.url : '';
    if (!rawUrl) return false;

    try {
      var pathname = new URL(rawUrl, window.location.origin).pathname;
      return /\/cart\/(add|change)(\.js)?\/?$/.test(pathname);
    } catch (error) {
      return false;
    }
  }

  function syncKeyValueBody(body) {
    if (!body || typeof body.get !== 'function' || typeof body.set !== 'function') return body;

    var mainValue = body.get('properties[Parche]') || '';
    var extraValue = body.get('properties[Parche extra]') || '';
    var mainMessage = getMessage('main', mainValue);
    var extraMessage = getMessage('extra', extraValue);

    if (typeof body.delete === 'function') {
      body.delete('properties[' + MAIN_NOTICE_KEY + ']');
      body.delete('properties[' + EXTRA_NOTICE_KEY + ']');
    }

    if (mainMessage) body.set('properties[' + MAIN_NOTICE_KEY + ']', mainMessage);
    if (extraMessage) body.set('properties[' + EXTRA_NOTICE_KEY + ']', extraMessage);

    return body;
  }

  var originalFetch = window.fetch;

  if (typeof originalFetch === 'function') {
    window.fetch = function (input, init) {
      var nextInit = init;

      try {
        if (nextInit && nextInit.body && isCartPropertyEndpoint(input)) {
          if (typeof nextInit.body === 'string') {
            var contentType = '';
            var headers = nextInit.headers || {};

            if (headers instanceof Headers) {
              contentType = headers.get('Content-Type') || headers.get('content-type') || '';
            } else {
              contentType = headers['Content-Type'] || headers['content-type'] || '';
            }

            if (contentType.indexOf('application/json') !== -1 || nextInit.body.charAt(0) === '{') {
              var parsed = JSON.parse(nextInit.body);
              syncPayload(parsed);
              nextInit = Object.assign({}, nextInit, { body: JSON.stringify(parsed) });
            } else if (typeof URLSearchParams !== 'undefined') {
              var params = new URLSearchParams(nextInit.body);
              syncKeyValueBody(params);
              nextInit = Object.assign({}, nextInit, { body: params.toString() });
            }
          } else if (
            (typeof FormData !== 'undefined' && nextInit.body instanceof FormData) ||
            (typeof URLSearchParams !== 'undefined' && nextInit.body instanceof URLSearchParams)
          ) {
            syncKeyValueBody(nextInit.body);
          }
        }
      } catch (error) {
        console.warn('CDF patch messages: no se pudo sincronizar el aviso del carrito.', error);
      }

      return originalFetch.call(this, input, nextInit);
    };
  }

  function ensureStyle() {
    if (document.getElementById('cdf-patch-selection-message-style')) return;

    var style = document.createElement('style');
    style.id = 'cdf-patch-selection-message-style';
    style.textContent = [
      '.cdf-patch-selection-message{font-size:13px;line-height:1.45;color:#4b5560;background:#f7f7f7;border:1px solid #e5e5e5;border-radius:12px;padding:10px 12px;margin-top:8px;white-space:pre-line;}',
      '.cdf-patch-selection-message[hidden]{display:none!important;}'
    ].join('');
    document.head.appendChild(style);
  }

  function ensureMessageBox(anchor, kind, context) {
    if (!anchor || !anchor.parentNode) return null;

    var selector = '[data-cdf-patch-message-box="' + context + '-' + kind + '"]';
    var existing = anchor.parentNode.querySelector(selector);
    if (existing) return existing;

    var box = document.createElement('div');
    box.className = 'cdf-patch-selection-message';
    box.setAttribute('data-cdf-patch-message-box', context + '-' + kind);
    box.setAttribute('role', 'status');
    box.setAttribute('aria-live', 'polite');
    box.hidden = true;
    anchor.insertAdjacentElement('afterend', box);
    return box;
  }

  function updateMessageBox(box, message) {
    if (!box) return;
    var cleanMessage = String(message || '').trim();
    box.textContent = cleanMessage;
    box.hidden = !cleanMessage;
  }

  function ensurePdpNoticeInput(root, kind) {
    if (!root) return null;

    var form = root.closest('form');
    if (!form) return null;

    var selector = '[data-cdf-patch-notice-input="' + kind + '"]';
    var input = form.querySelector(selector);

    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + getNoticeKey(kind) + ']';
      input.setAttribute('data-cdf-patch-notice-input', kind);
      input.disabled = true;
      form.appendChild(input);
    }

    return input;
  }

  function getPdpPatchValue(root, kind) {
    var isExtra = kind === 'extra';
    var optionSelector = isExtra ? '[data-extra-patch-option].is-selected' : '[data-patch-option].is-selected';
    var valueAttribute = isExtra ? 'data-extra-patch-value' : 'data-patch-value';
    var selected = root.querySelector(optionSelector);

    if (selected) return selected.getAttribute(valueAttribute) || '';

    var propertyName = isExtra ? 'Parche extra' : 'Parche';
    var propertyInput = root.querySelector('input[name="properties[' + propertyName + ']"]:not([data-cdf-patch-notice-input])');
    return propertyInput && !propertyInput.disabled ? propertyInput.value || '' : '';
  }

  function syncPdpKind(root, kind) {
    if (!root) return;

    var isExtra = kind === 'extra';
    var wrapper = root.querySelector(isExtra ? '[data-extra-patch-wrapper]' : '[data-patch-wrapper]');
    var propertyName = isExtra ? 'Parche extra' : 'Parche';
    var propertyInput = root.querySelector('input[name="properties[' + propertyName + ']"]:not([data-cdf-patch-notice-input])');
    var anchor = wrapper || (propertyInput ? propertyInput.closest('.product-personalization__field') : null);
    if (!anchor) return;

    var message = getMessage(kind, getPdpPatchValue(root, kind));
    var box = ensureMessageBox(anchor, kind, 'pdp');
    var noticeInput = ensurePdpNoticeInput(root, kind);

    updateMessageBox(box, message);

    if (noticeInput) {
      noticeInput.value = message;
      noticeInput.disabled = !message;
    }
  }

  function syncPdp(root) {
    syncPdpKind(root, 'main');
    syncPdpKind(root, 'extra');
  }

  function scanPdp(scope) {
    var context = scope || document;
    context.querySelectorAll('[data-product-personalization]').forEach(syncPdp);
  }

  function getSelectedButton(container, selector) {
    return container ? container.querySelector(selector + '.is-selected') : null;
  }

  function syncPackKind(builder, kind) {
    if (!builder) return;
    var field = kind === 'extra' ? 'extra-patch' : 'patch';
    var container = builder.querySelector('[data-pack-patches="' + field + '"]');
    if (!container) return;

    var selected = getSelectedButton(container, '[data-pack-patch-option]');
    var message = getMessage(kind, selected ? selected.getAttribute('data-value') || '' : '');
    var box = ensureMessageBox(container, kind, 'pack');
    updateMessageBox(box, message);
  }

  function syncPack(builder) {
    syncPackKind(builder, 'main');
    syncPackKind(builder, 'extra');
  }

  function syncCartModalKind(modal, kind) {
    if (!modal) return;
    var container = modal.querySelector(kind === 'extra' ? '[data-modal-extra-patches]' : '[data-modal-patches]');
    if (!container) return;

    var selected = getSelectedButton(container, '.cart-personalization-form__patch');
    var message = getMessage(kind, selected ? selected.getAttribute('data-value') || '' : '');
    var box = ensureMessageBox(container, kind, 'cart-modal');
    updateMessageBox(box, message);
  }

  function syncCartModal(modal) {
    syncCartModalKind(modal, 'main');
    syncCartModalKind(modal, 'extra');
  }

  function installPackBuilderBridge() {
    if (!window.customElements || typeof window.customElements.whenDefined !== 'function') return;

    window.customElements.whenDefined('pack-builder').then(function () {
      var PackBuilder = window.customElements.get('pack-builder');
      if (!PackBuilder || !PackBuilder.prototype || PackBuilder.prototype.__cdfPatchMessagesInstalled) return;

      var originalSaveLine = PackBuilder.prototype.saveLine;
      if (typeof originalSaveLine !== 'function') return;

      PackBuilder.prototype.saveLine = function () {
        var modalWasOpen = !!(this.modal && !this.modal.classList.contains('is-hidden'));
        var editingUid = this.editingUid;
        var previousCount = Array.isArray(this.lines) ? this.lines.length : 0;
        var result = originalSaveLine.apply(this, arguments);
        var savedSuccessfully = modalWasOpen && this.modal && this.modal.classList.contains('is-hidden');

        if (savedSuccessfully && Array.isArray(this.lines)) {
          var line = editingUid
            ? this.lines.find(function (item) { return item.uid === editingUid; })
            : this.lines.length > previousCount
              ? this.lines[this.lines.length - 1]
              : null;

          if (line && line.properties) {
            syncProperties(line.properties);
            if (typeof this.renderLines === 'function') this.renderLines();
          }
        }

        return result;
      };

      PackBuilder.prototype.__cdfPatchMessagesInstalled = true;
    });
  }

  function schedule(callback) {
    window.setTimeout(callback, 0);
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || typeof target.closest !== 'function') return;

    var pdpOption = target.closest('[data-patch-option], [data-extra-patch-option], [data-toggle-trigger="patch"], [data-toggle-trigger="extra-patch"]');
    if (pdpOption) {
      var pdpRoot = pdpOption.closest('[data-product-personalization]');
      schedule(function () { syncPdp(pdpRoot); });
    }

    var packTarget = target.closest('[data-pack-patch-option], [data-pack-add-product], [data-pack-edit]');
    if (packTarget) {
      var builder = packTarget.closest('pack-builder');
      schedule(function () { syncPack(builder); });
    }

    var cartTarget = target.closest('.cart-personalization-form__patch, [data-cart-personalize-open], [data-modal-toggle-trigger="patch"], [data-modal-toggle-trigger="extra-patch"]');
    if (cartTarget) {
      var modal = document.querySelector('[data-cart-personalization-modal]');
      schedule(function () { syncCartModal(modal); });
    }
  });

  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || typeof target.matches !== 'function') return;

    if (target.matches('[data-pack-toggle="patch"], [data-pack-toggle="extra-patch"]')) {
      var builder = target.closest('pack-builder');
      schedule(function () { syncPack(builder); });
    }
  });

  document.addEventListener('shopify:section:load', function (event) {
    scanPdp(event.target);
    schedule(function () {
      document.querySelectorAll('pack-builder').forEach(syncPack);
      var modal = document.querySelector('[data-cart-personalization-modal]');
      if (modal) syncCartModal(modal);
    });
  });

  ensureStyle();
  installPackBuilderBridge();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scanPdp(document);
      document.querySelectorAll('pack-builder').forEach(syncPack);
      var modal = document.querySelector('[data-cart-personalization-modal]');
      if (modal) syncCartModal(modal);
    });
  } else {
    scanPdp(document);
    document.querySelectorAll('pack-builder').forEach(syncPack);
    var modal = document.querySelector('[data-cart-personalization-modal]');
    if (modal) syncCartModal(modal);
  }
})();
